import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, heroBadges, heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-10 md:pb-24 md:pt-16" data-id="element-93" data-mp="4lqfmm6wsuyr">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-94" data-mp="4jm5hmif2zq1">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-95" data-mp="1285x3nzc5smb">
          <h1 className="mx-auto max-w-4xl text-[2.375rem] font-extrabold leading-[1.05] tracking-tight text-slate-900 [text-wrap:balance] sm:text-5xl md:text-6xl" data-id="element-96" data-mp="sarvgui2n8e2">
            {brand.headline}{' '}
            <span className="text-blue-600" data-id="element-97" data-mp="3d21sryrtemo9">{brand.headlineAccent}</span>
          </h1>
          <h2 className="mx-auto mt-4 max-w-2xl text-base font-semibold leading-snug text-slate-600 [text-wrap:balance] md:mt-5 md:text-xl" data-id="element-98" data-mp="382p6bf4uvhm7">
            {brand.productName}
          </h2>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} src={heroImage} alt={brand.mockupCaption} className="mx-auto mt-8 w-full max-w-2xl md:mt-10" width={1240} height={1240} data-id="element-99" data-mp="3o85blc7uc353" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.18,
        ease
      }} className="mx-auto mt-8 max-w-3xl md:mt-10" data-id="element-100" data-mp="30gq65akrp5pm">
          <p className="text-lg leading-relaxed text-slate-700 [text-wrap:pretty] md:text-2xl" data-id="element-101" data-mp="2viy3blil3z6n">{brand.subtitle}</p>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-slate-600" data-id="element-102" data-mp="2hina4btsy8ib">
            {heroBadges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5" data-id="element-103" data-mp="2lml82j7e5d9s">
                <CheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-104" data-mp="s3ck463mvbog" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-105" data-mp="ibow6f6accrq">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-106" data-mp="icrnupbfmj8p">
              Quiero los 50 Mapas ahora
            </CtaButton>
          </div>

          <p className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-slate-600" data-id="element-107" data-mp="1b0w05toidukd">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-108" data-mp="161t0ypv7mikb" />
            Garantía de 7 días o te devolvemos tu dinero
          </p>
        </motion.div>
      </div>
    </section>;
}